import React, { useState, createContext, useContext, useEffect } from "react";

const MessageContext = createContext();
const MessageActionsContext = createContext();

export const useMessageContext = () => useContext(MessageContext);
export const useMessageActionsContext = () => useContext(MessageActionsContext);

export function MessageContextProvider({ children }) {
  const [showmessage, setShowMessage] = useState(false);
  const [issuceess, setIsSuccess] = useState(false);
  const [message, setMessage] = useState("");

  const setMessageFromAPI = (isShowMessage, isSuccessOrError, message) => {
    setShowMessage(isShowMessage);
    setIsSuccess(isSuccessOrError);
    setMessage(message);
  };

  useEffect(() => {
    const timeout = setTimeout(resetSuccessErrorMessage, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [showmessage, issuceess, message]);

  const resetSuccessErrorMessage = () => {
    setShowMessage(false);
    setIsSuccess(false);
    setMessage("");
  };

  return (
    <MessageContext.Provider
      value={{
        showmessage,
        issuceess,
        message,
      }}
    >
      <MessageActionsContext.Provider
        value={{ setMessageFromAPI, resetSuccessErrorMessage }}
      >
        {children}
      </MessageActionsContext.Provider>
    </MessageContext.Provider>
  );
}
